module.exports = __webpack_public_path__ + "img/chicken.5ebacd6f.jpg";